module.exports = __webpack_public_path__ + "static/new-video-ebb3b6209071c2304d41d5fbceabfc32.mp4";